import { giphyGreen } from '@giphy/js-brand'
import { Toggle } from '@giphy/react-giphy-brand'
import React, { useContext } from 'react'
import { useHistory } from 'react-router'
import SearchOptionsContext from 'shared/components/context/search-options'
import { googleAnalyticsEvent, trackPageView } from 'shared/util/analytics'
import styled, { css } from 'styled-components'

const getPathname = (term: string, isStickerMode: boolean) => {
    const gifUrl = `${term
        .replace(/stickers|sticker|transparent/gi, '')
        .trim()
        .replace(/\s+/g, '-')}`
    return `/search/${gifUrl}${isStickerMode ? `-stickers` : ``}${document.location.search}`
}
type Props = {
    term: string
    width?: number
    height?: number
}
const SearchTypeToggle = ({ term, width = 206, height = 28 }: Props) => {
    const { setType, type } = useContext(SearchOptionsContext)
    const history = useHistory()
    return (
        <ToggleContainer
            toggle={() => {
                const nextType = type === 'gifs' ? 'stickers' : 'gifs'
                setType(nextType)
                const pathname = getPathname(term, nextType === 'stickers')
                setTimeout(() => {
                    googleAnalyticsEvent({
                        category: `Search Page`,
                        action: `${type} Toggle`,
                        label: term,
                    })
                    trackPageView(pathname)
                }, 50)
                history.replace(pathname, history.location.state)
            }}
            isOn={type === 'gifs'}
            height={height}
            width={width}
            offColor={giphyGreen}
            onElement={<div>GIFs</div>}
            offElement={<div>Stickers</div>}
        />
    )
}

export default SearchTypeToggle

// not sure why this needs a height
const ToggleContainer = styled(Toggle)<{ height: number }>`
    font-size: 14px;
    font-weight: 700;
    letter-spacing: 0.01em;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    flex-shrink: 0;
    ${props =>
        props.height &&
        css`
            height: ${props.height}px;
        `}
`
